import TrainingSession from '../session';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSession.index(({ trainingId }, fetch) => {
    return fetch.get(`/trainings/${trainingId}/sessions`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
